import { defineComponent, h, useAttrs } from 'vue'

function stripLegacyAttrs(attrs = {}) {
  const normalized = { ...attrs }

  delete normalized.class
  delete normalized.dense
  delete normalized.height
  delete normalized.light

  return normalized
}

export default defineComponent({
  name: 'VSimpleTableCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        'div',
        {
          ...stripLegacyAttrs(attrs),
          class: [
            'v-data-table',
            'theme--light',
            {
              'v-data-table--dense':
                attrs.dense === '' ||
                attrs.dense === true ||
                attrs.dense === 'true'
            },
            attrs.class
          ]
        },
        [
          h(
            'div',
            {
              class: 'v-data-table__wrapper',
              style: attrs.height
                ? { height: attrs.height, overflowY: 'auto' }
                : undefined
            },
            [h('table', slots.default?.())]
          )
        ]
      )
  }
})
